import React from "react";
import { BankAccountDetails } from "./BankAccountDetails";
import NoBankAccountsMessageBox from "components/MessageBox/NoBankAccountsMessageBox";

interface Props {
  bankAccounts: server.dto.BankAccountSmall[]
}

export const BankAccountsSection = ({ bankAccounts }: Props) => {
  return <div className="flex-column gap">
    <div className="nav-text-regular">{RESX.BankAccount.BankAccounts}</div>
    {bankAccounts.length === 0 && <NoBankAccountsMessageBox type="info" />}
    {bankAccounts.map(bankAccount =>
      <BankAccountDetails key={bankAccount.bankAccountId} bankAccount={bankAccount} />
    )}
  </div>
}